// extracted by mini-css-extract-plugin
module.exports = {"section":"Banner_section__qeofl","avatar":"Banner_avatar__fvwd2","image":"Banner_image__5mqwM","title":"Banner_title__dGBGs","description":"Banner_description__gCAn0"};